import { SVGProps } from 'react';

const PhoneCallIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg height="24" width="25" fill="none" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M19.6315 16.61L18.4585 15.437C17.8725 14.851 16.9225 14.851 16.3375 15.437L15.4155 16.359C15.2095 16.565 14.8975 16.634 14.6315 16.517C13.2955 15.932 11.9755 15.045 10.7985 13.868C9.62653 12.696 8.74253 11.382 8.15653 10.051C8.03453 9.776 8.10553 9.453 8.31853 9.24L9.14453 8.414C9.81553 7.743 9.81553 6.794 9.22953 6.208L8.05653 5.035C7.27553 4.254 6.00953 4.254 5.22853 5.035L4.57653 5.686C3.83553 6.427 3.52653 7.496 3.72653 8.556C4.22053 11.169 5.73853 14.03 8.18753 16.479C10.6365 18.928 13.4975 20.446 16.1105 20.94C17.1705 21.14 18.2395 20.831 18.9805 20.09L19.6315 19.439C20.4125 18.658 20.4125 17.392 19.6315 16.61V16.61Z"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M13.667 6.99099C14.698 6.97699 15.734 7.35899 16.521 8.14599"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M19.349 5.318C17.78 3.749 15.723 2.964 13.667 2.964"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M17.6755 11C17.6895 9.969 17.3075 8.933 16.5205 8.146"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M19.3486 5.318C20.9176 6.887 21.7026 8.944 21.7026 11"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default PhoneCallIcon;
